import * as React from 'react'

export default function DiscoIcon(props: {
  size?: string | number
}): React.ReactElement<'svg'> {
  return (
    <svg
      width={props.size ?? 18}
      height={props.size ?? 18}
      viewBox="0 0 220.61 261.98"
      fill="currentColor"
      aria-hidden="true"
    >
      <polygon points="102.35 0 37.02 87.33 83.88 87.33 18.56 174.65 65.32 174.65 0 261.98 118.3 261.98 183.59 174.65 136.84 174.65 202.15 87.33 155.31 87.33 220.61 0 102.35 0" />
    </svg>
  )
}
